import React, { useEffect, useRef, useState } from "react";
import { Alert, Badge, Button, Col, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { OrderScanner } from "./OrderScanner";
import Swal from "sweetalert2";
import { errorMsg } from "../../../Global/helpers";
import * as pharmaCrud from '../../_redux/pharma/pharmaCrud'
import * as actions from "../../_redux/pharma-deliveries/pharmaDeliveriesActions";


const useFocus=()=>{
    const htmlElRef=useRef(null);
    const setFocus= ()=>{htmlElRef.current && htmlElRef.current.focus()}
    return [htmlElRef, setFocus]
}

export function OrderPickingDialog({ show, onHide, ordersAvailable }) {
    const [error, setError] = useState(false)
    const inputRef = useRef(null);
    const [ordersToReceive, setOrdersToReceive] = useState([])


    useEffect(()=>{
        setOrdersToReceive([])
    }, [show])

    return (
        <>
    
            <Modal show={show} onHide={onHide}  size="xl" backdrop='static'>
                <Modal.Header closeButton>
                    <Modal.Title id="armar-pedido-dialog">
                        Recepción de órdenes
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <OrderScanner ordersToReceive={ordersToReceive} setOrdersToReceive={setOrdersToReceive} ordersAvailable={ordersAvailable}/>
                

                    <div className="text-right mt-4">
                        <Button variant="default" type="button" onClick={onHide}>
                            Cerrar
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
